<template>
    <span :class="{'text-sans-serif':!label && remaining, 'font-weight-400':true}" v-if="label || remaining !== 'aN:aN'">{{ label || remaining }}</span>
</template>

<script>
import moment from "moment";

export default {
    props: ['secondsLeft', 'label'],

    computed: {
        hours() {
            return Math.floor(this.secondsLeft / 60 / 60);
        },

        minutes() {
            return Math.floor(this.secondsLeft / 60 - this.hours * 60);
        },

        seconds() {
            return Math.floor(this.secondsLeft - this.minutes * 60);
        },

        remaining() {
            if (this.hours) {
                return `${("0" + this.hours).slice(-2)}:${("0" + this.minutes).slice(-2)}:${("0" + this.seconds).slice(-2)}`;
            } else {
                return `${("0" + this.minutes).slice(-2)}:${("0" + this.seconds).slice(-2)}`;
            }
        },
    },
}
</script>